import PropTypes from 'prop-types';

/**
 * Spinner Component (Preline UI)
 *
 * A loading spinner component with Preline/Tailwind styling.
 * Provides visual feedback for loading states.
 *
 * @param {Object} props
 * @param {string} [props.size='md'] - Size of the spinner ('sm', 'md', 'lg')
 * @param {string} [props.color='brand'] - Color theme of the spinner
 * @param {string} [props.className] - Additional CSS classes
 */
export function Spinner({ size = 'md', color = 'brand', className = '' }) {
  const sizeClasses = {
    sm: 'size-6',
    md: 'size-8',
    lg: 'size-12',
  };

  const colorClasses = {
    brand: 'text-brand',
    gray: 'text-subtle',
    white: 'text-white',
  };

  return (
    <div
      className={`animate-spin inline-block ${sizeClasses[size]} border-[3px] border-current border-t-transparent ${colorClasses[color]} rounded-full ${className}`}
      role="status"
      aria-label="loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}

Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.oneOf(['brand', 'gray', 'white']),
  className: PropTypes.string,
};
